import sidebarData from '@/data/docs/sidebar.json';
import { SidebarNavigationRouteType } from '@/store/navigation/types';

export const sidebarNavData: SidebarNavigationRouteType[] = Object.values(sidebarData);
